import { render, staticRenderFns } from "./SectionOsagoHero.vue?vue&type=template&id=2368d92f&scoped=true&"
import script from "./SectionOsagoHero.vue?vue&type=script&lang=ts&"
export * from "./SectionOsagoHero.vue?vue&type=script&lang=ts&"
import style0 from "./SectionOsagoHero.vue?vue&type=style&index=0&id=2368d92f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2368d92f",
  null
  
)

export default component.exports